import React from "react"
import DesktopCheckoutFooter from "./desktop/DesktopCheckoutFooter"
import MobileCheckoutFooter from "./mobile/MobileCheckoutFooter"

const FooterCheckout = () => {
	return (
		<>
			<div className={"d-none d-md-block"}>
				<DesktopCheckoutFooter/>
			</div>
			<div className={"d-block d-md-none"}>
				<MobileCheckoutFooter/>
			</div>
		</>
	)
}

export default FooterCheckout
